document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initGaleria();
  initVariantes();
  initPacks();
  initBarraFija();
  initUpsell();
});

function initUpsell() {
  document.querySelectorAll('[data-dk-producto]').forEach(function (root) {
    var modal = document.querySelector('[data-dk-upsell]');
    var form = root.querySelector('form[action^="/cart/add"]') || root.querySelector('form');
    if (!modal || !form) return;

    var cantidadInput = root.querySelector('[data-dk-cantidad]');
    var addBtn = root.querySelector('[data-dk-add-btn]');
    var siBtn = modal.querySelector('[data-dk-upsell-si]');
    var noBtn = modal.querySelector('[data-dk-upsell-no]');
    var cerrarBtn = modal.querySelector('[data-dk-upsell-cerrar]');
    var omitir = false;

    function enviarFormulario() {
      var formData = new FormData(form);
      fetch('/cart/add.js', { method: 'POST', body: formData })
        .then(function () { window.location.href = '/cart'; })
        .catch(function () { omitir = true; form.submit(); });
    }

    form.addEventListener('submit', function (e) {
      var cantidadActual = cantidadInput ? cantidadInput.value : '1';
      if (!omitir && cantidadActual === '1') {
        e.preventDefault();
        modal.classList.add('dk-upsell-visible');
      }
    });

    if (siBtn) {
      siBtn.addEventListener('click', function () {
        if (cantidadInput) cantidadInput.value = '2';
        modal.classList.remove('dk-upsell-visible');
        enviarFormulario();
      });
    }
    if (noBtn) {
      noBtn.addEventListener('click', function () {
        modal.classList.remove('dk-upsell-visible');
        omitir = true;
        if (addBtn) addBtn.click();
      });
    }
    if (cerrarBtn) {
      cerrarBtn.addEventListener('click', function () {
        modal.classList.remove('dk-upsell-visible');
      });
    }
  });
}

function initBarraFija() {
  var barra = document.querySelector('[data-dk-barra-fija]');
  var addBtn = document.querySelector('[data-dk-add-btn]');
  if (!barra || !addBtn) return;

  var barraBtn = barra.querySelector('[data-dk-barra-btn]');
  var barraPrecio = barra.querySelector('[data-dk-barra-precio]');
  var precioActual = document.querySelector('[data-dk-precio-actual]');

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        barra.classList.toggle('dk-barra-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
      });
    },
    { threshold: 0 }
  );
  observer.observe(addBtn);

  if (barraBtn) {
    barraBtn.addEventListener('click', function () {
      if (addBtn.disabled) return;
      addBtn.click();
    });
  }

  if (precioActual && barraPrecio) {
    var syncPrecio = function () { barraPrecio.textContent = precioActual.textContent; };
    syncPrecio();
    new MutationObserver(syncPrecio).observe(precioActual, { childList: true, characterData: true, subtree: true });
  }
}

function initPacks() {
  document.querySelectorAll('[data-dk-packs]').forEach(function (grupo) {
    var packs = grupo.querySelectorAll('[data-dk-pack]');
    var root = grupo.closest('[data-dk-producto]');
    if (!root) return;
    var cantidadInput = root.querySelector('[data-dk-cantidad]');
    var precioActual = root.querySelector('[data-dk-precio-actual]');
    var precioAnterior = root.querySelector('[data-dk-precio-anterior]');

    packs.forEach(function (pack) {
      pack.addEventListener('click', function () {
        packs.forEach(function (p) {
          p.classList.remove('dk-pack-activo');
          p.setAttribute('aria-checked', 'false');
        });
        pack.classList.add('dk-pack-activo');
        pack.setAttribute('aria-checked', 'true');

        if (cantidadInput) cantidadInput.value = pack.getAttribute('data-dk-pack');

        var precioEl = pack.querySelector('.dk-pack-precio');
        var tachadoEl = pack.querySelector('.dk-pack-precio-tachado');
        if (precioActual && precioEl) precioActual.textContent = precioEl.textContent;
        if (precioAnterior) {
          if (tachadoEl) {
            precioAnterior.textContent = tachadoEl.textContent;
            precioAnterior.style.display = '';
          } else {
            precioAnterior.style.display = 'none';
          }
        }
      });
    });
  });
}

function initReveal() {
  var els = document.querySelectorAll('.dk-reveal');
  if (!els.length) return;

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    els.forEach(function (el) { el.classList.add('dk-visible'); });
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('dk-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
  );

  els.forEach(function (el, i) {
    el.style.setProperty('--dk-i', i % 8);
    observer.observe(el);
  });
}

function initGaleria() {
  document.querySelectorAll('[data-dk-galeria]').forEach(function (galeria) {
    var main = galeria.querySelector('[data-dk-galeria-principal]');
    var minis = galeria.querySelectorAll('[data-dk-galeria-mini]');
    if (!main || !minis.length) return;

    minis.forEach(function (mini) {
      mini.addEventListener('click', function () {
        var full = mini.getAttribute('data-full');
        var alt = mini.getAttribute('data-alt') || '';
        if (!full) return;
        main.style.opacity = '0';
        window.setTimeout(function () {
          main.src = full;
          main.alt = alt;
          main.style.opacity = '1';
        }, 150);
        minis.forEach(function (m) { m.classList.remove('dk-activa'); });
        mini.classList.add('dk-activa');
      });
    });
  });
}

function initVariantes() {
  document.querySelectorAll('[data-dk-producto]').forEach(function (root) {
    var dataEl = root.querySelector('[data-dk-variantes-json]');
    if (!dataEl) return;

    var variants;
    try {
      variants = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }

    var pills = root.querySelectorAll('[data-dk-pill]');
    var idInput = root.querySelector('[data-dk-variant-id]');
    var precioActual = root.querySelector('[data-dk-precio-actual]');
    var precioAnterior = root.querySelector('[data-dk-precio-anterior]');
    var addBtn = root.querySelector('[data-dk-add-btn]');
    var stockEstado = root.querySelector('[data-dk-stock-estado]');

    function formatMoney(cents) {
      var amount = (cents / 100).toFixed(2).replace('.', ',');
      var symbolo = ((window.Shopify && Shopify.currency && Shopify.currency.active) === 'USD') ? '$' : '€';
      return symbolo + amount;
    }

    function seleccionActual() {
      var seleccion = {};
      root.querySelectorAll('[data-dk-opcion]').forEach(function (grupo) {
        var activa = grupo.querySelector('.dk-pill-activa');
        if (activa) seleccion[grupo.getAttribute('data-dk-opcion')] = activa.getAttribute('data-value');
      });
      return seleccion;
    }

    function encontrarVariante() {
      var seleccion = seleccionActual();
      return variants.find(function (v) {
        return Object.keys(seleccion).every(function (key) {
          return v.options[key] === seleccion[key];
        });
      });
    }

    function actualizar() {
      var variante = encontrarVariante();
      if (!variante) return;

      if (idInput) idInput.value = variante.id;
      if (precioActual) precioActual.textContent = formatMoney(variante.price);
      if (precioAnterior) {
        if (variante.compare_at_price && variante.compare_at_price > variante.price) {
          precioAnterior.textContent = formatMoney(variante.compare_at_price);
          precioAnterior.style.display = '';
        } else {
          precioAnterior.style.display = 'none';
        }
      }
      if (addBtn) {
        addBtn.disabled = !variante.available;
        addBtn.textContent = variante.available
          ? addBtn.getAttribute('data-label-disponible')
          : addBtn.getAttribute('data-label-agotado');
      }
      if (stockEstado) {
        stockEstado.textContent = variante.available
          ? stockEstado.getAttribute('data-label-disponible')
          : stockEstado.getAttribute('data-label-agotado');
        stockEstado.className = 'dk-stock-estado ' + (variante.available ? 'dk-stock-disponible' : 'dk-stock-agotado');
      }

      pills.forEach(function (p) {
        var grupo = p.getAttribute('data-dk-opcion');
        var val = p.getAttribute('data-value');
        var testSel = Object.assign({}, seleccionActual());
        testSel[grupo] = val;
        var existe = variants.some(function (v) {
          return Object.keys(testSel).every(function (k) { return v.options[k] === testSel[k]; });
        });
        p.classList.toggle('dk-pill-agotada', !existe);
      });
    }

    pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        var grupo = pill.getAttribute('data-dk-opcion');
        root.querySelectorAll('[data-dk-opcion="' + grupo + '"]').forEach(function (p) {
          p.classList.remove('dk-pill-activa');
        });
        pill.classList.add('dk-pill-activa');
        actualizar();
      });
    });

    actualizar();
  });
}
